export const API_URL: string = 'https://norma.nomoreparties.space/api';
export const WS_API_URL: string = 'wss://norma.nomoreparties.space';